import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Agent, AgentClient, AgentService, DocumentAgents, DocumentAgentsClient, DocumentClient, Documents, DocumentServiceClient, DocumentServiceProviderClient, DocumentServiceProviders, DocumentServices, DocumentTypeClient, DocumentTypes, NServices, ServiceClient, ServiceProvider, ServiceProvidersClient } from "src/app/web-api-client";
import { DocumentTypeLink, DocumentTypeLinkConverter } from "../../../../models/documentTypeLink.enum";
import { SigningType, SigningTypeConverter } from "../../../../models/signing-Type.enum";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";

@Component({
  selector: 'app-document-creation',
  templateUrl: './document-creation.component.html',
  styleUrls: ['./document-creation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentCreationComponent implements OnInit  {

  public includeDocument: boolean = false;
  public step: number = 1;
  public isLoaded = false;
  public services: Document[];
  public documentTypes: DocumentTypes[] = [];
  public filePath = "";
  Form: FormGroup;
  public response: { dbPath: '' } = {dbPath:''};
  public SigningType = SigningType;
  public signingTypes = Object.keys(SigningType).filter(
    key => !isNaN(Number(SigningType[key]))
  );

  public DocumentTypeLink = DocumentTypeLink;
  public documentTypeLink = Object.keys(DocumentTypeLink).filter(
    key => !isNaN(Number(DocumentTypeLink[key]))
  );

  public selectedServiceProvider: ServiceProvider;
  public selectedService: NServices;
  public selectedAgent: Agent;
  public allServices: NServices[] = [];
  public allServiceProviders: ServiceProvider[] = [];
  public allAgents: Agent[] = [];
  public loadedService: boolean = false;
  public loadedServiceProvider: boolean = false;
  public loadedAgents: boolean = false;
  public onClose = new Subject<boolean>();

  constructor(private fb: FormBuilder,public changeDetecRef:ChangeDetectorRef,public activeModal: NgbActiveModal,public client:DocumentClient,public docServiceClient:DocumentServiceClient,public docServiceProviderClient:DocumentServiceProviderClient,public docAgentClient:DocumentAgentsClient,public serviceClient:ServiceClient,public serviceProviderClient:ServiceProvidersClient,public agentClient:AgentClient,public docTypeClient:DocumentTypeClient) { }

  ngOnInit(): void {

    this.docTypeClient.getList().subscribe(s => {

      this.documentTypes = s;
      this.initializeForm();
      this.isLoaded = true;
      this.changeDetecRef.detectChanges();
    });
  }

  initializeForm() {


    this.Form = this.fb.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
      documentTypes: ['', Validators.required],
      isGlobal: [false, Validators.required],
      signedType: [+SigningType.NoSigning, Validators.required],
      isActive: [null, Validators.required],
      order: [0, Validators.required],
    });


  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }

  onSubmit() {
    if (this.Form.valid) {

      let service =new Documents();

      service.idDocument = 0;
      service.title = this.Form.value.title;
      service.description = this.Form.value.description;
      service.idDocumentType = this.Form.value.documentTypes;
      service.isGlobal = this.Form.value.isGlobal;
      service.signedType = SigningTypeConverter.GetValueById(this.Form.value.signedType);
      service.isActive = this.Form.value.isActive;
      service.path = this.response.dbPath;




      this.client.create(service).subscribe((result) => {

          this.onClose.next(true);
          this.activeModal.close();
      });
    }
  }

  goToStep(step: number): void {
    //if (step === 2 ) {
    //  // Validate the file upload here
    //  return;
    //}
    this.step = step;

    this.changeDetecRef.detectChanges();
  }

  onFileSelected(event: any): void {

    this.response = event;
    this.goToStep(2);
  }






  onServiceChange(selectedValue: string) {

    this.selectedService = this.allServices.find(d => d.idService == +selectedValue);
    this.changeDetecRef.detectChanges();

  }

  onServiceProviderChange(selectedValue: string) {
    this.selectedServiceProvider = this.allServiceProviders.find(d => d.idServiceProvider == +selectedValue);
    this.changeDetecRef.detectChanges();
  }

  onAgentChange(selectedValue: string) {
    this.selectedAgent = this.allAgents.find(d => d.idAgent == +selectedValue);
    this.changeDetecRef.detectChanges();
  }


  public getSigningType(linkType: string) {
    return SigningTypeConverter.getSigningTranslation(linkType);
  }

  public getDocTypeLink(linkType: string) {
    return DocumentTypeLinkConverter.getDocumentTypeLinkTranslation(linkType);
  }


  onCheckboxChange() {


    this.includeDocument = !this.includeDocument;

    if (!this.includeDocument) {
      this.response.dbPath = '';
    }

    this.changeDetecRef.detectChanges();
  }

  public getFileName(path: string): string {
  // Replace backslashes with forward slashes for consistency
  const normalizedPath = path.replace(/\\/g, '/');
  // Split the path by '/' and get the last segment
  const segments = normalizedPath.split('/');
  return segments[segments.length - 1];
}

}
